import { Injectable } from '@angular/core';
import { CityParkingUserLineDto, cityParkingProvinceListResponse } from '../../models/lineOA.model';
import { ParkingFeeForMemberResponse } from '../../models/register-parking';
import { ParkingVehicleTypeResponse } from '../../models/vehicle.model';
import {
  RegisterMemberCardStaffResult,
  RegisterMemberCardStaffResultDto,
  StaffFeeOption,
  StaffLineUserOption,
  StaffProvinceOption,
  StaffVehicleTypeOption,
} from '../../models/cityparking/register-member-card-staff.model';

@Injectable({
  providedIn: 'root',
})
export class MapperRegisterMemberCardStaffService {
  mapResult(dto: RegisterMemberCardStaffResultDto | Record<string, unknown>): RegisterMemberCardStaffResult {
    const raw = dto as RegisterMemberCardStaffResultDto & Record<string, unknown>;
    return {
      isSuccess: this.bool(raw.isSuccess ?? raw['IsSuccess']),
      message: this.str(raw.message ?? raw['Message']),
      messageEn: this.str(raw.messageEn ?? raw['MessageEn']),
      idReturn: this.num(raw.idReturn ?? raw['IdReturn']),
      requestNo: this.str(raw.requestNo ?? raw['RequestNo']),
      paymentUrl: this.str(raw.paymentUrl ?? raw['PaymentUrl']),
      feeAmount: this.num(raw.feeAmount ?? raw['FeeAmount']),
      vatAmount: this.num(raw.vatAmount ?? raw['VatAmount']),
      total: this.num(raw.total ?? raw['Total']),
      lineSent: this.bool(raw.lineSent ?? raw['LineSent']),
      cpUserId: this.num(raw.cpUserId ?? raw['CpUserId']),
      temporaryUser: this.bool(raw.temporaryUser ?? raw['TemporaryUser']),
    };
  }

  mapLineUsers(rows: CityParkingUserLineDto[]): StaffLineUserOption[] {
    return (rows ?? [])
      .map((row) => ({
        cpUserId: row.id ?? 0,
        name: row.name ?? '',
        fullName: row.fullName ?? '',
        uid: row.uid ?? '',
        phone: row.phone ?? '',
        pictureUrl: row.pictureUrl ?? '',
      }))
      .filter((row) => row.cpUserId > 0 && row.uid.trim() !== '');
  }

  mapFees(rows: ParkingFeeForMemberResponse[]): StaffFeeOption[] {
    return (rows ?? []).map((row) => ({
      id: row.id ?? 0,
      feeId: row.feeId ?? 0,
      feeName: row.feeName ?? '',
      amount: row.amount ?? 0,
    }));
  }

  mapVehicleTypes(rows: ParkingVehicleTypeResponse[]): StaffVehicleTypeOption[] {
    return (rows ?? []).map((row) => ({
      id: row.id ?? 0,
      typeName: row.typeName ?? '',
    }));
  }

  mapProvinces(rows: cityParkingProvinceListResponse[]): StaffProvinceOption[] {
    return (rows ?? [])
      .map((row) => ({
        id: row.id ?? 0,
        name: row.name ?? '',
      }))
      .filter((row) => row.id > 0 && row.name.trim() !== '');
  }

  qrImageUrl(paymentUrl: string): string {
    return `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(paymentUrl)}`;
  }

  private str(value: unknown): string {
    return typeof value === 'string' ? value : value == null ? '' : String(value);
  }

  private num(value: unknown): number {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  }

  private bool(value: unknown): boolean {
    return value === true || value === 'true';
  }
}
